import { ModifierDto } from '@symphony-solo/domain/modifiers/src';
import { PriceLevelDto } from '@symphony-solo/domain/price-levels/src';
import { TransactionUnitPriceDto } from '../dtos';

export class TransactionUnitPriceBuilder {
  private transactionUnitPrice: TransactionUnitPriceDto;

  constructor() {
    this.transactionUnitPrice = new TransactionUnitPriceDto();
  }

  public setModifier(modifier: ModifierDto): TransactionUnitPriceBuilder {
    this.transactionUnitPrice.modifier = new ModifierDto(modifier.id, modifier.name);
    return this;
  }

  public setPriceLevel(priceLevel: PriceLevelDto): TransactionUnitPriceBuilder {
    this.transactionUnitPrice.priceLevel = new PriceLevelDto(priceLevel.id, priceLevel.name);
    return this;
  }

  public setPortionSize(portionSize: number): TransactionUnitPriceBuilder {
    this.transactionUnitPrice.portionSize = portionSize;
    return this;
  }

  public setOriginalPrice(originalPrice: number): TransactionUnitPriceBuilder {
    this.transactionUnitPrice.originalPrice = originalPrice;
    return this;
  }

  public build(): TransactionUnitPriceDto {
    return this.transactionUnitPrice;
  }
}
